module.exports = __webpack_public_path__ + "img/猪肉.28bf3524.png";